// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"eN","sticky_header_title":"fN","stycky_header_title_mob":"gN","root_scroller":"hN","scroller":"iN","indicator":"jN","scrollButtons":"kN","selected":"lN","root_tab_scrollable":"mN","root_scroller_mob":"nN","scroller_mob":"oN","indicator_mob":"pN","selected_mob":"qN","root_tab_mob":"rN","root_tab_mob_scrollable":"sN","sticky_header_title_mob":"tN"};
    if(module.hot) {
      // 1711717533927
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  